import {
  Middleware,
  MiddlewareAPI,
  isRejectedWithValue,
} from '@reduxjs/toolkit';
import Cookies from 'js-cookie';
import { setNotification } from '../slices/notificationsSlice';
import { setToken } from '../slices/usersSlice';

export const rtkQueryAuthErrorMiddleware: Middleware =
  (api: MiddlewareAPI) => (next) => (action) => {
    if (isRejectedWithValue(action)) {
      if (action.payload?.data?.response?.errors) {
        // get ready for insanity

        const sub_code =
          action.payload.data.response.errors[0]?.extensions?.sub_code ?? '';

        if (sub_code === 'invalid_access_token') {
          const token = Cookies.get('ragya-token');
          if (token) {
            Cookies.remove('ragya-token');
            Cookies.remove('ragya-token', { path: '' });
            api.dispatch(setToken({ token: '' }));
            api.dispatch(
              setNotification({
                message:
                  "You've logged in on another device. Redirecting to login...",
                type: 'info',
              })
            );
            setTimeout(() => (window.location.href = '/login'), 3000);
          }
        } else {
          if (action.payload.data.response.errors[0].message) {
            api.dispatch(
              setNotification({
                type: 'error',
                message: action.payload.data.response.errors[0].message,
              })
            );
          } else {
            api.dispatch(
              setNotification({
                type: 'error',
                message: 'Something went wrong. Please try again later',
              })
            );
          }
        }
      }
    }
    return next(action);
  };
